import { Component, OnInit, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LoadingSpinnerComponent } from '@shared/components/loading-spinner/loading-spinner.component';
import { PushNotificationService } from '@core/services/notification/push-notification.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingSpinnerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('patient-portal');
  private readonly pushNotificationService = inject(PushNotificationService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.pushNotificationService.listenToNotificationClicks((fullUrl, rawUrl) => {
      if (rawUrl.startsWith('/')) {
        this.router.navigateByUrl(rawUrl);
      } else {
        window.open(fullUrl, '_blank');
      }
    });
  }
}
